// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Wishlist_main-container__owO9n"};